import $ from "jquery";
import "./summaryPagePortal.scss";
import "jquery-validation";
import { createPDF } from "../../../../core/customFunctions/createPDF";
import {
  pergola,
  toggleBackWall,
  toggleLoad,
} from "../../../../core/3d-configurator";
import { state } from "../../../../core/settings";

function saveFormData() {
  const formData = {
    firstname: $("#firstname").val(),
    phoneNumber: $("#phoneNumber").val(),
    email: $("#email").val(),
    country: $("#country").val(),
    agree: $("#agree").is(":checked"),
  };
  sessionStorage.setItem("summaryFormData", JSON.stringify(formData));
}

let currentMode = 'quote';

export function loadFormData(container, mode = 'quote') {
  currentMode = mode;

  const title = mode === 'download'
    ? 'Fill in details below to Download PDF:'
    : 'Fill in details below to Request a quote:';
  const submitLabel = mode === 'download' ? 'Download PDF' : 'Request A Quote';

  $(`${container} .form__header__title`).text(title);
  $(`${container} #form button[type="submit"]`).text(submitLabel);

  const savedData = JSON.parse(sessionStorage.getItem("summaryFormData"));

  if (savedData) {
    $(`${container} #firstname`).val(savedData.firstname);
    $(`${container} #phoneNumber`).val(savedData.phoneNumber);
    $(`${container} #email`).val(savedData.email);
    $(`${container} #country`).val(savedData.country);
    $(`${container} #agree`).prop("checked", savedData.agree);
  }
}

export function summaryPagePortalComponent(container, downloadPDF = true) {
  const html = $(`
    <div class='summary-portal' id='sum-portal'>
      <div class="form-container">
        <form class="form" id="form">
          <div class="form__header">
            <h2 class="form__header__title">
              Fill in details below to Request a quote:
            </h2>

            <button type="button" id="closeForm" class="form__header__close"></button>
          </div>
          
       
          <div class="form__top">
              <div class="form__group">
                <input class="form__input" type="text" id="firstname" name="firstname" class="form-control" placeholder="First & Last name*">
              </div>

              <div class="form__group">
                <input class="form__input" type="text" id="phoneNumber" name="phoneNumber" class="form-control" placeholder="Telephone">
              </div>
          </div>

          
          <div class="form__top">
            <div class="form__group">
              <input class="form__input" type="text" id="city" name="city" class="form-control" placeholder="City*">
            </div>

          <div class="form__group">
              <input class="form__input" type="text" id="country" name="country" class="form-control" placeholder="Country*">
            </div>
          </div>

          <div class="form__group">
              <input class="form__input" type="email" id="email" name="email" class="form-control" placeholder="Email*">
            </div>

          <div class="form__check">
            <input type="checkbox" id="agree" name="agree" class="form__check-input">
            <label for="agree" class="form__check__label">
               By downloading this PDF and using our 3d Visualiser, you consent to Louvretec collecting, processing and storing your personal data for our use only, in accordance with our privacy policy.
            </label>
          </div>

          <div class="form__buttons">
            <button type="button" id="cancelButton" class="form__buttons__button form__buttons__button--back">Cancel</button>
            <button type="submit" class="form__buttons__button">
              Request A Quote
            </button>
          </div>
        </form>
      </div>
    </div>
  `);

  html.hide();
  const form = html.find("#form");

  $(container).append(html);

  $.validator.addMethod(
    "phoneNumber",
    function (value, element) {
      const regex = /^[0-9]{7}$/;
      return this.optional(element) || regex.test(value);
    },
    "Please enter a valid phone number (7 digits)."
  );

  $.validator.addMethod(
    "country",
    function (value, element) {
      return this.optional(element) || value.length > 4;
    },
    "Please write a country."
  );

  form.validate({
    rules: {
      firstname: {
        required: true,
        minlength: 2,
      },
      phoneNumber: {
        required: true,
        phoneNumber: true,
      },
      email: {
        required: true,
        email: true,
      },
      "country": {
        required: true,
        country: true,
      },
      city: {
        required: true,
        minlength: 2,
      },
      agree: {
        required: true,
      },
    },
    messages: {
      firstname: {
        required: "Please enter your first name",
        minlength: "Your name must be at least 2 characters long",
      },
      phoneNumber: {
        required: "Please enter your phone number",
        phoneNumber: "Phone number must be 7 digits",
      },
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address",
      },
      "country": {
        required: "Please write a country",
        country: "Country must be more than 4 characters",
      },
      city: {
        required: "Please enter your city",
        minlength: "City name must be at least 2 characters long",
      },
      agree: {
        required: "You must agree to the terms and conditions",
      },
    },
    submitHandler: async function (form, event) {
      event.preventDefault();

      saveFormData();

      sendFormDataToGoogleSheets();

      if (currentMode === 'download') {
        toggleLoad(true);

        if (!state.dayMode) {
          $("#switchButton-time").trigger("click");
          await createPDF("download");
          $("#switchButton-time").trigger("click");
        } else {
          await createPDF("download");
        }

        toggleLoad(false);
      }

      html.hide();
    },
  });

  const cancelButton = html.find("#cancelButton");
  const closeButton = html.find("#closeForm");

  closeButton.on("click", function () {
    if (false) {
      toggleLoad(true);
      $("html, body").animate({ scrollTop: 0 }, "fast", () => {
        $("#summary-content").hide();
        $("body").removeClass("body-overflow-auto");
      });
      toggleLoad(false);
      html.hide();
    } else {
      html.hide();
      $("body").addClass("body-overflow-auto");
    }
  });

  cancelButton.on("click", function () {
    if (false) {
      toggleLoad(true);
      $("html, body").animate({ scrollTop: 0 }, "fast", () => {
        $("#summary-content").hide();
        $("body").removeClass("body-overflow-auto");
      });
      toggleLoad(false);
      html.hide();
    } else {
      $("#form")[0].reset();
      form.validate().resetForm();
      html.hide();
      $("body").addClass("body-overflow-auto");
    }
  });
}

function sendFormDataToGoogleSheets() {
  // SCRIPT_ID
  const scriptDeploymentId =
    "AKfycbxoz1obgOk155rWxE5vLgRXoVCXXCn-D_5XK61fzeHhZSV0m52r7JVn-BgFOe9H1v2aIQ";

  let uri = window.location.href;

  $.ajax({
    url: `https://script.google.com/macros/s/${scriptDeploymentId}/exec`,
    method: "POST",
    data: {
      name: $("#firstname").val(),
      email: $("#email").val(),
      phone: $("#phoneNumber").val(),
      country: $("#country").val(),
      city: $("#city").val(),
      uri: uri,
      width: state.width.toFixed(1),
      length: state.length.toFixed(1),
      height: state.height.toFixed(1),
      frameStyle: state.colorBody,
      louvreColor: state.colorRoof,
    },
    success: function (response) {
      console.log("Data sent successfully:", response);
    },
    error: function (error) {
      console.error("Error:", error);
    },
  });
}
